import {Component, OnChanges, OnInit} from '@angular/core';
import {TeArtefactDto} from "../../../model/dto/entity/te-artefact.dto";
import {TeArtefactService} from "../../../service/api/te-artefact.service";
import {TinymceAutosave} from '../../../logic/tinymce-autosave';
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {TeEditorSaveEvent} from "../te-editor/te-editor.component";

@Component({
    selector: 'mvs-te-artefact-object',
    templateUrl: './te-artefact-object.component.html',
    standalone: false
})
export class TeArtefactObjectComponent
  extends ObjectBaseComponent
  implements OnInit, OnChanges {

  dto: TeArtefactDto;
  crudService: TeArtefactService;

  widgetBasicData: WidgetData;
  showBasicData: boolean;
  private autoSave =  new TinymceAutosave();


  /**
   * Save content.
   * @param event
   */
  handleEditorOnSave(event: TeEditorSaveEvent) {

    const dto = new TeArtefactDto();
    dto.id = this.dto.id;
    dto.content = event.content;
    dto.editorTypeEnum = event.editorTypeEnum;

    this.crudService.update(dto).subscribe({
      next: (value) => {
        this.dto.editorTypeEnum = event.editorTypeEnum;
        this.messageService.showSuccessMessageSaved();
        console.log('Updated content data into API');
        let editorContentFromCookie = this.autoSave.getAutoSaveCookie('te.TeArtefactVariable'+this.dto.id);
        if (editorContentFromCookie && dto.content === editorContentFromCookie?.content) {
          this.autoSave.deleteAutoSaveCookie('te.TeTemplateVariable'+this.dto.id);
          this.dto = <TeArtefactDto>value; // take over value
        }
      },
      error: (error) => {
        this.messageService.showErrorMessage('Fehler', 'Ein Fehler ist aufgetreten.');
      }
    });

  }

  handleToggleBasicData() {

    if (this.showBasicData) {
      this.widgetBasicData = WidgetFactory.createWidgetEntityData(
          'te.config.artefact.view',
          'Artefakt',
          this.objectIdentifier.objectType,
          this.objectIdentifier.objectId
      );

    } else {
      this.widgetBasicData = null;
    }
  }
}
